<template>
  <div class="panel">
    <el-row>
      <h1>欢迎为Tigo框架贡献代码</h1>
      <div class="content">Tigo是一款开源框架，我们欢迎所有的开发向我们提出宝贵的意见以及贡献代码。贡献代码之前请开发者阅读项目中的相关README文件，</div>
      <div class="content">首先从Github上Fork一份代码，按照代码规范增加您的代码，然后发送一个Pull请求，我们会对您的代码进行相应的merge。</div>
    </el-row>
    <el-row>
      <img src="../../assets/contribute.png" class="contribute"/>
    </el-row>
  </div>
</template>

<script>
  export default {
    name: "DocumentationContribute"
  }
</script>

<style scoped>
  .panel {
    height: 450px;
    width: 100%;
    background-color: #ffffff;
  }

  h1 {
    margin-top: 30px;
  }

  .content {
    color: #797e8e;
    font-family: "Avenir", serif;
  }

  .contribute {

  }

  @media screen and (max-width: 1005px) {
    .contribute{
      display: none;
    }
    .panel {
      height: auto;
      width: 100%;
      background-color: #ffffff;
      padding-bottom: 30px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ch/DocumentationContribute.vue